import { useExperimentBucket } from '@carvana/experiment';
import { useContext } from 'react';
import InventoryContext from '~/contexts/InventoryContext';
import ResultTiles from './SimilarResults';
import { SimilarResultsHeader } from './SimilarResultSection.styles';
import { ResultsSection } from '../ResultsSection.styles';

export default function SimilarResultsSection() {
  const {
    similarVehicles: { vehicles }
  } = useContext(InventoryContext);
  const hasSimilarResults = vehicles.length > 0;
  const experimentBucket = useExperimentBucket('srch-set-reduction2');

  return hasSimilarResults ? (
    <>
      {experimentBucket === 'show-zero-counts' ? (
        <div className="pb-16 t-header-m text-blue-7 text-center m:pb-24 m:t-header-xl">
          View Similar Vehicles
        </div>
      ) : (
        <SimilarResultsHeader data-qa="similar-results-wrapper">
          Check out similar matches
        </SimilarResultsHeader>
      )}
      <ResultsSection>
        <ResultTiles vehicles={vehicles} />
      </ResultsSection>
    </>
  ) : null;
}
